module.exports = __webpack_public_path__ + "img/couples-074.39b6e162.jpg";